module.exports = __webpack_public_path__ + "img/Desk Stationary A32.a4f9983d.jpg";